export const IMAGES = {
  logo: 'https://cdn.magicpatterns.com/uploads/aNzwRe8Sg621BnhoXwCyhP/Logo_Codigo_metabolico.png',
  colibri:
    'https://cdn.magicpatterns.com/uploads/w4UwedyNBbvEX5TLpHgnfd/Metabolismo_Colibri.png',
  jaguar:
    'https://cdn.magicpatterns.com/uploads/tUWNkQsvUodKM4joTd5NiB/Metabolismo_Jaguar.png',
  oso: 'https://cdn.magicpatterns.com/uploads/qyTWDmriB14xknkGREh3kc/Metabolismo_OSO.png',
  cover:
    'https://cdn.magicpatterns.com/uploads/xiSKuR6mrWqYspKY7n4oqp/Portada_de_FB.png',
}

export type MetabolicType = 'jaguar' | 'colibri' | 'oso'

export interface Option {
  text: string
  type: MetabolicType
}

export interface Question {
  id: number
  question: string
  options: Option[]
  weight: number
}

export const QUIZ_QUESTIONS: Question[] = [
  {
    id: 1,
    question: '¿Cómo es tu energía a lo largo del día?',
    weight: 2,
    options: [
      { text: 'Estable y constante, rara vez tengo bajones', type: 'oso' },
      { text: 'Alta en la mañana pero bajo mucho en la tarde', type: 'jaguar' },
      { text: 'Sube y baja varias veces, es impredecible', type: 'colibri' },
    ],
  },
  {
    id: 2,
    question:
      'Después de comer arroz, pasta o pan en cantidad, ¿cómo te sientes?',
    weight: 2,
    options: [
      { text: 'Me da sueño o me siento pesado/a', type: 'jaguar' },
      { text: 'Normal, no noto mucho cambio', type: 'oso' },
      {
        text: 'Me siento bien al inicio pero luego me da hambre rápido',
        type: 'colibri',
      },
    ],
  },
  {
    id: 3,
    question: '¿Qué pasa cuando te saltas una comida?',
    weight: 2,
    options: [
      {
        text: 'Me mareo, me pongo de mal humor o me tiemblan las manos',
        type: 'colibri',
      },
      {
        text: 'Puedo aguantar sin problema, no me afecta mucho',
        type: 'jaguar',
      },
      { text: 'Me da hambre pero puedo esperar sin problemas', type: 'oso' },
    ],
  },
  {
    id: 4,
    question: '¿Con qué frecuencia sientes hambre durante el día?',
    weight: 1,
    options: [
      { text: 'Cada 2-3 horas, necesito comer algo', type: 'colibri' },
      {
        text: 'En mis horarios normales de comida (3 veces al día)',
        type: 'oso',
      },
      {
        text: 'Pocas veces, puedo pasar horas sin pensar en comida',
        type: 'jaguar',
      },
    ],
  },
  {
    id: 5,
    question:
      '¿Cómo te sientes después de una comida rica en proteína (carne, pollo, huevos)?',
    weight: 2,
    options: [
      { text: 'Satisfecho/a y con energía por varias horas', type: 'jaguar' },
      {
        text: 'Bien pero necesito acompañarlo con carbohidratos para sentirme completo/a',
        type: 'oso',
      },
      {
        text: 'Me lleno rápido pero al rato ya tengo hambre otra vez',
        type: 'colibri',
      },
    ],
  },
  {
    id: 6,
    question: '¿Cómo describirías tu digestión normalmente?',
    weight: 1,
    options: [
      { text: 'Rápida, proceso los alimentos sin problema', type: 'jaguar' },
      {
        text: 'A veces me siento hinchado/a o pesado/a después de comer',
        type: 'colibri',
      },
      { text: 'Regular y sin molestias la mayoría del tiempo', type: 'oso' },
    ],
  },
  {
    id: 7,
    question: '¿Qué describe mejor tu relación con tu peso?',
    weight: 1,
    options: [
      { text: 'Subo y bajo de peso con facilidad', type: 'colibri' },
      { text: 'Tiendo a subir de peso si no me cuido', type: 'oso' },
      { text: 'Me cuesta subir de peso aunque coma bastante', type: 'jaguar' },
    ],
  },
  {
    id: 8,
    question: '¿Cómo es tu sueño y recuperación?',
    weight: 1,
    options: [
      { text: 'Duermo bien y me despierto con energía', type: 'oso' },
      {
        text: 'Me cuesta dormir o me despierto en la madrugada',
        type: 'colibri',
      },
      { text: 'Duermo profundo pero me cuesta despertar', type: 'jaguar' },
    ],
  },
]

export const RESULT_CONTENT = {
  jaguar: {
    title: 'Jaguar',
    image: IMAGES.jaguar,
    explanation:
      'Tu cuerpo responde mejor a una alimentación que prioriza proteína y energía controlada. Eres un cazador natural, tu metabolismo está diseñado para ráfagas de energía y periodos de ayuno o comidas espaciadas.',
  },
  colibri: {
    title: 'Colibrí',
    image: IMAGES.colibri,
    explanation:
      'Tu cuerpo quema energía rápidamente y necesita combustible constante. Respondes mejor a comidas más pequeñas y frecuentes con una buena mezcla de carbohidratos complejos para mantener tu metabolismo acelerado.',
  },
  oso: {
    title: 'Oso',
    image: IMAGES.oso,
    explanation:
      'Tu metabolismo es fuerte y estable. Tu cuerpo responde bien a una alimentación equilibrada con comidas completas y tradicionales.',
  },
}
